import icon from 'vue-svgicon';

icon.register({
    'bold/synchronize-arrow-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12.567 1.258A10.822 10.822 0 0 0 2.818 8.4a.25.25 0 0 1-.271.163L.858 8.309a.514.514 0 0 0-.485.213.5.5 0 0 0-.021.53l2.679 4.7a.5.5 0 0 0 .786.107l3.77-3.746a.5.5 0 0 0-.279-.85l-1.715-.256a.25.25 0 0 1-.192-.35 8.259 8.259 0 1 1 7.866 11.59 1.25 1.25 0 0 0 .045 2.5h.047a10.751 10.751 0 1 0-.792-21.487z"/>`,
    },
});
